// extracted by mini-css-extract-plugin
module.exports = {"reviewtabMinWidth":"415px","content_loader_area":"_3LXXOJ","inner":"X0p76z","AniFadeIn":"Y3KsZ_","AniFadeOut":"_9vm9Fn","AniRotate":"_8H5hNG","AniPlaceholderFadeOut":"LpGWI1"};